module.exports = __webpack_public_path__ + "media/images/nomiri_og-9d74dd9e91b581b5a4620a7460099bd3.png";